import { resolveSchemaRepoBranch, resolveSchemaRepoUrl } from '../api/env';

export interface SchemaGitSettings {
  repoUrl: string;
  branch: string;
}

const STORAGE_KEY = 'dc-admin.schema-git-settings';

/** 部署默认值（env / config.js），用户可在界面覆盖并持久化到 localStorage。 */
export function getDefaultSchemaGitSettings(): SchemaGitSettings {
  return {
    repoUrl: resolveSchemaRepoUrl(),
    branch: resolveSchemaRepoBranch(),
  };
}

export function loadSchemaGitSettings(): SchemaGitSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return getDefaultSchemaGitSettings();
    }
    const parsed = JSON.parse(raw) as Partial<SchemaGitSettings>;
    const defaults = getDefaultSchemaGitSettings();
    return {
      repoUrl: String(parsed.repoUrl ?? '').trim() || defaults.repoUrl,
      branch: String(parsed.branch ?? '').trim() || defaults.branch,
    };
  } catch {
    return getDefaultSchemaGitSettings();
  }
}

export function saveSchemaGitSettings(settings: SchemaGitSettings): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      repoUrl: settings.repoUrl.trim(),
      branch: settings.branch.trim() || 'master',
    }),
  );
}
